import { createContext } from 'react';

type PeriodSelectionContextType = {
  onSelectPeriod: (period: string) => void;
  resetToFirstPeriod: () => void;
};

export const PeriodSelectionContext = createContext<PeriodSelectionContextType | undefined>(undefined);
